import { requestMiddleware } from '@/utils';
import { taxAxios } from '@/utils/taxAxios';


/** 发送验证码 */
export const getSendSms = (params) => {
  return requestMiddleware(taxAxios.get(`/api/dbc/client/sendSms`, { params }))
}

/** 发送验证码 */
export const postCigAuth = (data) => {
  return requestMiddleware(taxAxios.post(`/api/dbc/taxation/tobacco/cig/auth`, data))
}